import { render, staticRenderFns } from "./CalcPropListPanel.vue?vue&type=template&id=38bd8f42&scoped=true"
import script from "./CalcPropListPanel.vue?vue&type=script&lang=js"
export * from "./CalcPropListPanel.vue?vue&type=script&lang=js"
import style0 from "./CalcPropListPanel.vue?vue&type=style&index=0&id=38bd8f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd8f42",
  null
  
)

export default component.exports